export const summaryTabCreditRatingNamesPriorites = [
  'Issuer Rating',
  'Issuer Rating (foreign currency)',
];
